const BarChart = ({ data }) => {
  const maxValue = 400;

  const getBarColor = (label) => {
    const colors = {
      Ideas: "#10B981",
      Screened: "#3B82F6",
      Prototype: "#F59E0B",
      Pilot: "#EF4444",
      Commercialized: "#06B6D4",
    };
    return colors[label] || "#9CA3AF";
  };

  const yAxisLabels = [400, 300, 200, 100, 0];

  return (
    <div className="flex gap-2 md:gap-4 outline-none" tabIndex="-1">
      {/* Y-axis labels */}
      <div className="flex flex-col justify-between py-2 text-[10px] md:text-xs text-gray-400">
        {yAxisLabels.map((label) => (
          <div key={label} className="h-6 md:h-8 flex items-center">
            {label}
          </div>
        ))}
      </div>

      {/* Chart area */}
      <div className="flex-1 relative overflow-x-auto">
        {/* Horizontal dashed lines */}
        <div className="absolute inset-0 flex flex-col justify-between py-2">
          {yAxisLabels.map((label, i) => (
            <div key={i} className="h-6 md:h-8 border-t border-dashed border-gray-300" />
          ))}
        </div>
        
        {/* Bar chart */}
        <div className="flex items-end justify-center gap-2 md:gap-4 h-full relative px-4 md:px-8 min-w-[300px]">
          {data.map((item, index) => {
            const heightPercentage = (item.value / maxValue) * 100;
            
            return (
              <div key={index} className="flex flex-col items-center flex-1 h-full justify-end max-w-[50px] md:max-w-[70px]">
                <div className="relative w-full flex items-end justify-center h-full pb-2">
                  <div
                    className="w-full rounded-t transition-all duration-300 hover:opacity-80"
                    style={{
                      height: `${heightPercentage}%`,
                      backgroundColor: getBarColor(item.label),
                      minHeight: item.value > 0 ? "20px" : "0",
                    }}
                  />
                </div>
                <div className="text-[10px] md:text-xs text-gray-400 mt-2 text-center whitespace-nowrap">{item.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BarChart;
